import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import HorStepper from '../../navigation/horStepper';
import SelectPathToSQLComponent from './components/selectPathToSQLComponent';
import SelectSQLFilesComponent from './components/selectSQLFilesComponent';
import UpdatingSQLComponent from './components/updatingSQLComponent';
import ResultComponent from './components/resultComponent';
import SelectEnvComponent from './components/selectEnvComponent';
import { dataService } from '../../services/data/data.service';
import { toast } from 'react-toastify';
import MessageDialog from '../../base/dialogs/messageDialog';

export default function UpdateSQLPage(props) {
    const classes = useStyles();
    const [steps, setSteps] = useState([]);
    const [step, setStep] = useState(1);
    const [env, setEnv] = useState(props.appSettings.ENVIRONMENTS[0])
    const [path, setPath] = useState(null);
    const [sqlFiles, setSqlFiles] = useState([])
    const [executeResults, setExecuteResults] = useState([])
    const [backupDialogOpen, setBackupDialogOpen] = useState(false)

    const closeBackupDialog = () => {
        setBackupDialogOpen(false)
    }

    const execute = () => {
        if (sqlFiles.some(x => x.toBeExecuted)) {
            setBackupDialogOpen(true)
        }
        else {
            toast.error("Please select scripts", { position: toast.POSITION.TOP_CENTER })
        }
    }

    useEffect(() => {

        let stepsArray = [
            { "id": 1, "key": 1, "name": "Select env", "isComplete": false, "isInProgress": true, "hasPrevious": false, "hasNext": true, "formComponentName": "SelectEnvComponent" },
            { "id": 2, "key": 2, "name": "Select path", "isComplete": false, "isInProgress": true, "hasPrevious": true, "hasNext": true, "formComponentName": "SelectPathToSQLComponent" },
            { "id": 3, "key": 3, "name": "Select files", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "SelectSQLFilesComponent" },
            { "id": 4, "key": 4, "name": "Updating", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "UpdatingSQLComponent" },
            { "id": 5, "key": 5, "name": "Result", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": false, "formComponentName": "ResultComponent" }];
        stepsArray.map((x) => {
            if (x.id < step) {
                x.isComplete = true;
                x.isInProgress = false;
            } else if (x.id === step) {
                x.isInProgress = true;
                x.isComplete = false;
            } else {
                x.isComplete = false;
                x.isInProgress = false;
            }
        });

        if (JSON.stringify(steps) !== JSON.stringify(stepsArray)) {
            setSteps(stepsArray)
        }

    }, [step])

    const setPrevious = () => {
        if (step > 0) {
            setStep(step - 1)
        }
    }

    const setNext = () => {
        if (step < steps.length) {
            setStep(step + 1)
        }
    }

    const restart = () => {
        setEnv(props.appSettings.ENVIRONMENTS[0])
        setSqlFiles([])
        setExecuteResults([])
        setPath(null)
        setStep(1)
    }

    const changeEnv = (env) => {
        setEnv(props.appSettings.ENVIRONMENTS.find(x => x.id === env))
    }

    const changePath = (path) => {
        setPath(path)
    }

    const changeSqlFiles = (files) => {
        setSqlFiles(files)
    }

    const changeFileToBeExecuted = (name) => {
        let tempSQLFiles = [...sqlFiles]
        tempSQLFiles.find(x => x.name === name).toBeExecuted = !tempSQLFiles.find(x => x.name === name).toBeExecuted
        setSqlFiles(tempSQLFiles)
    }

    const executeSQLFiles = () => {  
        closeBackupDialog()      
        setNext()
        dataService.executeSQLScripts(sqlFiles, env.connectionString).then(
            results => {
                setExecuteResults(results.data)
                setTimeout(() => {
                    setStep(5)
                }, 3000)
            }
        )
    }

    return <div>
        {steps ?
            <React.Fragment> <HorStepper {...props} actions={props.actions} steps={steps} step={step} setStep={setStep}></HorStepper>
                <div className={classes.container}>
                    {
                        steps.map((x) => {
                            if (x.id === step) {
                                switch (x.formComponentName) {
                                    case "SelectEnvComponent":
                                        return (
                                            <SelectEnvComponent actions={props.actions} {...props} key="env" hasPrevious={x.hasPrevious} hasNext={x.hasNext} setPrevious={setPrevious} setNext={setNext} changeEnv={changeEnv} env={env} />)
                                    case "SelectPathToSQLComponent":
                                        return (
                                            <SelectPathToSQLComponent actions={props.actions} {...props} key="path" hasPrevious={x.hasPrevious} hasNext={x.hasNext} setPrevious={setPrevious} setNext={setNext} changePath={changePath} path={path} env={env} changeSqlFiles={changeSqlFiles} />)
                                    case "SelectSQLFilesComponent":
                                        return (
                                            <SelectSQLFilesComponent actions={props.actions} {...props} key="files" hasPrevious={x.hasPrevious} hasNext={x.hasNext} setPrevious={setPrevious} setNext={setNext} sqlFiles={sqlFiles} changeFileToBeExecuted={changeFileToBeExecuted} execute={execute} env={env} />)
                                    case "UpdatingSQLComponent":
                                        return (
                                            <UpdatingSQLComponent actions={props.actions} {...props} key="update" hasPrevious={x.hasPrevious} hasNext={x.hasNext} setPrevious={setPrevious} setNext={setNext} />)
                                    case "ResultComponent":
                                        return (
                                            <ResultComponent actions={props.actions} {...props} key="result" hasPrevious={x.hasPrevious} hasNext={x.hasNext} setPrevious={setPrevious} setNext={setNext} executeResults={executeResults} restart={restart} />)
                                    default:
                                        break;
                                }
                            }
                        })
                    }
                </div>
                <MessageDialog
                    closeDialog={closeBackupDialog}
                    dialogOpen={backupDialogOpen}
                    action={executeSQLFiles}
                    buttonCount={2}
                    buttonText="YES"
                    button2Text="NO"
                    messageTitle={"Backups taken??"}
                    messageContent={
                        <div>{"Backups from the database should be taken to avoid loss of data"}</div>
                    }>
                </MessageDialog>
            </React.Fragment>
            :
            <React.Fragment></React.Fragment>
        }

    </div>
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    }
});